import React from 'react';

export default () => {
    return(
        <div className={`header-arc`}>
            <img src={`/assets/images/header_arc.svg`} />
        </div>
    )
}